import { fmtCompact, pillHtml } from "../ui/kit";
import { currencyIconUrl } from "../ui/hub/econArt";
import { MARKET_TOPIC } from "../ui/hub/econTopics";
import { openMarket } from "../ui/hub/marketSheet";
import { sellRows } from "../ui/hub/marketModel";
import { ECONOMY_FROM_CLEARED, PILL_ORDER } from "./economy";
import type { Feature } from "./registry";
import "../ui/styles/market.css";

/** More-sheet slot: after Events (10), before the Guide (80): the order WP0 reserved (registry.ts MORE_ORDER). */
const MARKET_ORDER = 20;

/**
 * The NPC market (FINISH_PLAN WP5; owner decision D7): the Marks pill (tap → Shop → Marks), ⚙ → Market (the Trading
 * Post and the Black Market) and its Guide topic. The row's note names the tabs (the Mystery Merchant's door, Sell,
 * the Black Market) and counts spare gear the Trading Post would buy — a
 * fact about the player's stash, not an offer, and never a red dot (nothing here nudges a purchase).
 */
export const marketFeature: Feature = {
  id: "market",
  register(ctx, registry) {
    const unlocked = () => ctx.catalog.highestLevelCleared >= ECONOMY_FROM_CLEARED;
    const deps = (hub: Parameters<typeof openMarket>[0]["hub"]) => ({ hub, catalog: ctx.catalog, now: ctx.now });
    // Shop redesign (2026-10-19): no Marks pill on the hub; Marks show in the Shop's header where they are spent.
    registry.moreRow({
      id: "market", order: MARKET_ORDER, icon: "icons/shop_merchant.png",
      label: () => "Market",
      note: () => { const n = sellRows(ctx.catalog).rows.length; return n > 0 ? `Merchant · ${n} to sell · Black Market` : "Merchant · Sell · Black Market"; },
      visible: unlocked,
      open: (hub) => { openMarket(deps(hub)); },
    });
    registry.guideTopic(MARKET_TOPIC);
  },
};
